import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useKitchen } from "../../context/KitchenContext";
import { Link } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { IoMdArchive } from "react-icons/io";
import "./MyKitchens.css";

const MyKitchens = () => {
  const { user, loading: authLoading } = useContext(AuthContext);
  const { fetchAllKitchens, allKitchens, setAllKitchens } = useKitchen();
  const [kitchensLoaded, setKitchensLoaded] = useState(false);

  useEffect(() => {
    const fetchKitchens = async () => {
      if (user?.userID) {
        try {
          const kitchens = await fetchAllKitchens({
            userID: user.userID,
            forceRefresh: true,
          });
          setAllKitchens(kitchens.reverse());
          setKitchensLoaded(true);
        } catch (error) {
          console.error("Error fetching kitchens:", error);
          setKitchensLoaded(true);
        }
      }
    };
    fetchKitchens();
  }, [fetchAllKitchens, setAllKitchens, user?.userID]);

  // Smooth scrolling for internal anchor links (if needed)
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute("href"));
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
        });
      }
    });
  });

  if (authLoading) {
    return <p className="loading">Loading user data...</p>;
  }

  if (!user) {
    return (
      <p className="loading">Please log in or sign up to view your kitchens.</p>
    );
  }

  if (!kitchensLoaded) {
    return <p className="loading">Loading kitchens...</p>;
  }

  if (!allKitchens || allKitchens.length === 0) {
    return (
      <div className="my-kitchens-container">
        <h1>MY KITCHEN</h1>
        <p className="loading-kitchen">No kitchens available.</p>
        <div className="bottom-button-container">
          <Link to="/profile/add-kitchen" className="add-kitchen-btn">
            + New Kitchen
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="my-kitchens-container">
      <div className="kitchen-header-1">
        <h1>MY KITCHEN</h1>
        <div className="bottom-button-container">
          <Link to="/profile/add-kitchen" className="add-kitchen-btn">
            + New Kitchen
          </Link>
        </div>
      </div>
      <ul className="kitchens-list">
        {allKitchens.map((kitchen) => (
          <li key={kitchen.KitchenID} className="kitchen-item">
            <div className="my-kitchen-image">
              <img
                src={
                  kitchen.Images[0] ||
                  "https://airkitchenz-assets.s3.us-west-1.amazonaws.com/assets/KitchenComingSoon.png"
                }
                alt={kitchen.Title}
              />
            </div>
            <div className="kitchen-details">
              <h3>
                <Link to={`/kitchen/${kitchen.KitchenID}`}>
                  {kitchen.Title || "Kitchen"}
                </Link>
              </h3>
              <p>{kitchen.Description}</p>
              <p className="location">
                City: {kitchen.City} <br /> Area: {kitchen.Size}
              </p>
              <span
                className={`badge badge-${kitchen.KitchenStatus.toLowerCase()}`}
              >
                {kitchen.KitchenStatus}
              </span>
            </div>
            <div className="kitchen-price-status">
              <p className="price">
                $
                {kitchen.HourlyRate
                  ? kitchen.HourlyRate + "/hr"
                  : kitchen.DayRate + "/day"}
              </p>
              <p className="rating">⭐ {kitchen.Rating || "N/A"}</p>
            </div>
            <div className="kitchen-actions">
              <Link
                to={`/profile/edit-kitchen/${kitchen.KitchenID}`}
                className="edit-btn"
              >
                <FaEdit /> Edit
              </Link>
              <button className="archive-btn">
                <IoMdArchive /> Archive
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MyKitchens;
